// MapLoader.jsx
import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

const MapContext = createContext({ isLoaded: false });

export function MapProvider({ children, apiKey }) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey,
  });

  return <MapContext.Provider value={{ isLoaded }}>{children}</MapContext.Provider>;
}

export function useMapLoaded() {
  return useContext(MapContext).isLoaded;
}
